/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connections_GoogleInputs */



/**
* | output |
* | --- |
* | "Google Calendar" |
*
* @param {Connections_GoogleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const connections_google = /** @type {((inputs?: Connections_GoogleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connections_GoogleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Google Calendar")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Google Calendar")
	return /** @type {LocalizedString} */ ("Google Calendar")
});